module.exports = __webpack_public_path__ + "static/roca-bac245cb375b06ce6d1963d142393f1c.ttf";